import React from 'react'
import { number, string, array } from 'prop-types'
import numeral from 'numeral'
import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from 'Pods/Shared/Icon/Icon'

import PublishingScoreTooltip from './Components/PublishingScoreTooltip'

function PublishingScore({
  publishingScore,
  type,
  tagsLength,
  descriptionLength,
  imagesLength,
  embedsLength,
  files,
}) {
  const scoreColor = publishingScore >= 6 ? 'text-green' : 'text-warning'

  const tooltipContent = (
    <PublishingScoreTooltip
      descriptionLength={descriptionLength}
      tagsLength={tagsLength}
      imagesLength={imagesLength}
      embedsLength={embedsLength}
      files={files}
      type={type}
    />
  )

  return (
    <div className="card publishing-score">
      <div className="l-inner">
        Publishing score:
        {' '}
        <span className={scoreColor}>
          {numeral(publishingScore).format('0.0')}
        </span>
        <Tooltip
          id="publishing-score-tooltip"
          randomizeID
          content={tooltipContent}
          tooltipClassName="tooltip--publishing-score"
        >
          <Icon
            type={['fas', 'question-circle']}
            color="grey"
            className="ml-5"
          />
        </Tooltip>
      </div>
    </div>
  )
}

PublishingScore.propTypes = {
  publishingScore: number.isRequired,
  type: string.isRequired,
  tagsLength: number.isRequired,
  descriptionLength: number.isRequired,
  imagesLength: number.isRequired,
  embedsLength: number.isRequired,
  files: array.isRequired,
}

export default PublishingScore
